import React, { useState, useEffect } from 'react';
import Modal from '@/components/General/Modal';
import { createErrorNotification, createNotification } from '@/helper/ApiHelper';
import { useSelector } from 'react-redux';
import { AffiliateService } from '@/services/AffiliateService';
import { useCrudPageStateContext } from '@/context/CrudPageContext';
import { useEmployeesPageContext } from '../Employees/contexts/EmployeesPageContext';
import { useTranslation } from 'react-i18next';

export const DeleteEmployeeModal = () => {
  const { t } = useTranslation();
  const [isSaving, setIsSaving] = useState(false);
  const { refetchEmployees } = useEmployeesPageContext();
  const selectedAffiliate = useSelector((state) => state.affiliate.selectedAffiliate);
  const { openDeleteDialog, setOpenDeleteDialog, entityToDelete } = useCrudPageStateContext();

  useEffect(() => {
    if (!openDeleteDialog) {
      setIsSaving(false);
    }
  }, [openDeleteDialog]);

  const deleteUser = () => {
    if (!entityToDelete) return;

    setIsSaving(true);
    AffiliateService.deleteUserFromAffiliate(selectedAffiliate.id, entityToDelete.id)
      .then(async () => {
        createNotification(
          t('employee_page.notifications.delete_employee_header'),
          t('employee_page.notifications.delete_employee_message'),
          'success',
        );
        refetchEmployees();
        setOpenDeleteDialog(false);
      })
      .catch((err) => {
        createErrorNotification(err);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  return (
    <Modal
      modalName="delete_employee"
      headline={t('employee_page.modals.delete_employee_header')}
      isOpen={openDeleteDialog}
      isLoading={isSaving}
      primaryButtonText={'delete'}
      primaryButtonClass={'btn-error'}
      onSafe={deleteUser}
      onClose={() => setOpenDeleteDialog(false)}
    >
      <div className="space-y-1">
        <p className="w-full">
          {t('employee_page.modals.delete_employee_message', {
            userName: entityToDelete?.name || '',
          })}
        </p>
      </div>
    </Modal>
  );
};
